<template>
	<div class="add_backimg add_backimgTop clearfix">
		<div class="examIng_back"></div>
		<div class="examIng_head">
			<div class="examIng_headTitle">
				{{taskinfo.name}}
			</div>
			<div class="examIng_headTime">
				<img src="@/images/exam_time.png" />
				<span>剩余时间</span> {{hours}}:{{minutes}}:{{seconds}}
			</div>
			<div class="exam_exit" @click="exitExam">
				退出
			</div>
		</div>
		<div class="content minheight examIng_body clearfix ">
			<div class="examIng_left">
				<div class="examIng_infoHead">答题卡</div>
				<div class="examIng_infobody clearfix">
					<div class="questionAnswer" :class="questionWhere(item,index)" v-for="(item,index) in qusetionlist" @click="jumpQuestion(index,'jump')">
						{{index+1}}
					</div>
				</div>
				<div class="examIng_infoFoot">
					<el-button type="primary" @click='overitem'>提交试卷</el-button>
				</div>
			</div>
			<div class="examIng_right">
				<div class="examIng_infoHead" v-show="questionindex == index" v-for="(item,index) in qusetionlist">
					<span v-if="item.topicType == 1">单选题</span>
					<span v-if="item.topicType == 2">多选题</span>
					<span v-if="item.topicType == 3">判断题</span>
					<span v-if="item.topicType == 4">填空题</span>
					<span v-if="item.topicType == 5">简答题</span>
				</div>
				<div class="examQuestion_infobody clearfix">
					<questions @singleAnswer='({it,i,index})=>{singleAnswer(it,i,index)}' @multipleAnswer='({it,i,index})=>{multipleAnswer(it,i,index)}' @blanksAnswer='({index})=>{blanksAnswer(index)}' @uploadStatus="(newuploadFlag)=>{uploadFlag = newuploadFlag}" @uploadAnswer='uploadAnswer' @formFileRemove='formFileRemove' :questionsubmit='true' :qusetionlist='qusetionlist' :questionindex='questionindex'></questions>
				</div>
				<div class="examIng_infoFoot">
					<el-button @click="jumpQuestion(questionindex-1,'prve')" :disabled='questionindex<=0 || uploadFlag'>上一题</el-button>
					<el-button @click="jumpQuestion(questionindex+1,'next')" type="primary" :disabled='questionindex>=qusetionlist.length-1 || uploadFlag'>下一题</el-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { getExamineById, addExamRecord, getUserAnswerList, answer, commit } from '@/api/examine.js'
	import { topicByPaperId } from '@/api/paper.js'
	import { getInfo } from '@/api/user.js'
	import questions from '@/components/questions.vue'
	import questionsjs from '@/components/questions.js'
	export default {
		mixins: [questionsjs],
		components: {
			questions
		},
		data() {
			return {
				id: this.$route.query.id,
				userinfo: {},
				taskId: '',
				paperId: '',
				loading: true,
				isSubjectiveItem: false,
				loadingtext: '题目加载中...',
				questionindex: 0,
				questionove: [],
				qusetionlist: [],
				taskinfo: {},
				topicinfo: {},
				hours: '00',
				minutes: '00',
				seconds: '00',
				timelen: 900000, //15分钟
				timelaster: null,
				timeread: 5,
				timereader: null,
				userExamId: '',
				uploadFlag: false,
			}
		},
		created() {
			this.getMyInfo();
			this.getTaskitem();
		},
		mounted() {

		},
		watch: {

		},
		methods: {
			getMyInfo() {
				getInfo().then(res => {
					this.userinfo = res.data;
				})
			},
			delTime() {
				var timelen = this.timelen;
				var timelaster = setInterval(_ => {
					timelen -= 1000;
					this.timelen = timelen;
					if(timelen > 0) {
						var hours = parseInt((timelen % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
						hours = hours < 10 ? ('0' + hours) : hours
						this.hours = hours
						var minutes = parseInt((timelen % (1000 * 60 * 60)) / (1000 * 60));
						minutes = minutes < 10 ? ('0' + minutes) : minutes
						var seconds = (timelen % (1000 * 60)) / 1000;
						seconds = seconds < 10 ? ('0' + seconds) : seconds
						this.minutes = minutes
						this.seconds = seconds
					} else {
						this.hours = '00'
						this.minutes = '00'
						this.seconds = '00'
						clearInterval(timelaster)
						this.timelaster = null;
						this.tosubmit()
					}
				}, 1000);
				this.timelaster = timelaster
			},
			getTaskitem() {
				var data = {
					id: this.id
				}
				getExamineById(data).then(res => {
					if(res.code == "OK" && res.data) {
						this.taskinfo = res.data;
						this.timelen = res.data.timeSpent * 60 * 1000;
						res.data.paperList.map(item => {
							if(item.isUsing == '1') {
								this.paperId = item.id;
								this.topicinfo = item;
							}
						})
						this.getTaskinfo();
					}
				})
			},
			getTaskinfo() {
				var data = {
					id: this.paperId
				}
				topicByPaperId(data).then(res => {
					if(res.code == "OK") {
						this.qusetionlist = res.data;
						this.formInit().then(() => {
							this.loading = false;
							this.startAnswer()
						})
					}
				})
			},

			startAnswer() {
				var data = {
					examineId: this.id,
					paperId: this.paperId,
				}
				addExamRecord(data).then(res => {
					if(res.data.state == 0 || res.data.state == 3) {
						this.userExamId = res.data.id;
						var timeRemaining = res.data.timeRemaining;
						if(timeRemaining) {
							//this.timelen = timeRemaining //是否按照已使用时间倒计时
						}
						this.getUserAnswer();
					}
					if(res.data.state == 1) {
						this.$alert('此次考试您已交卷，请勿重复作答', '提示', {
							confirmButtonText: '确定',
						}).then(() => {
							this.$router.back(-1);
						}).catch(() => {
							this.$router.back(-1);
						})
					}
				})
			},
			getUserAnswer() {
				getUserAnswerList({
					recordId: this.userExamId
				}).then(res => {
					var qusetionlist = this.qusetionlist;
					var useranswers = res.data;
					qusetionlist.map(item => {
						useranswers.map(useranswer => {
							if(useranswer.topicId == item.id) {
								if(item.topicType != 4 && item.topicType != 5) {
									item.choose = useranswer.userAnswer.split('')
								} else {
									item.userAnswer = useranswer.userAnswer
								}
								if(item.topicType == 5 && useranswer.userAnswerFile && useranswer.userAnswerFile != '') {
									item.filearr = JSON.parse(useranswer.userAnswerFile);
									item.filesurl = useranswer.userAnswerFile;
								}
								item.over = true;
								item.overdata = true;
							}
						})
					})
					this.qusetionlist = qusetionlist;
					this.checkOver();
					this.delTime();
				})
			},
			overitem() {
				if(!this.uploadFlag) {
					var qusetionlist = this.qusetionlist;
					var questionove = this.questionove;
					var questionindex = this.questionindex;
					if(questionove.length == qusetionlist.length || (questionove.length == qusetionlist.length - 1 && qusetionlist[questionindex].overdata == false && qusetionlist[questionindex].over == true)) {
						this.$confirm('提交后将无法再修改，确认提交？', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {
							//都已提交,当前题目可能更改  || //只剩当前一题未提交，当前题目已答
							var userAnswer = '';
							if(qusetionlist[questionindex].topicType == 4 || qusetionlist[questionindex].topicType == 5) {
								userAnswer = qusetionlist[questionindex].userAnswer
							} else {
								userAnswer = qusetionlist[questionindex].choose.join('')
							}
							var data = {
								topicId: qusetionlist[questionindex].id,
								userAnswer: userAnswer,
								examineId: this.id,
								userExamId: this.userExamId,
								topicType: qusetionlist[questionindex].topicType,
								userAnswerFile: qusetionlist[questionindex].filesurl,
								timeRemaining: this.timelen,
							}
							answer(data).then(res => {
								if(res.code == "OK") {
									this.tosubmit()
								}
							})

						}).catch(() => {});
					} else {
						this.$message.error('还有未完成的题目')
					}
				} else {
					this.$message.info('正在上传文件。。。')
				}
			},
			checkOver() {
				var qusetionlist = this.qusetionlist;
				var questionove = [];
				qusetionlist.map((item, index) => {
					if(item.overdata == true) {
						questionove.push(index)
					}
				})
				this.questionove = questionove;
			},
			tosubmit() {
				this.loading = true;
				this.loadingtext = '正在提交...';
				var data = {
					examId: this.id,
					isSubjectiveItem: this.isSubjectiveItem,
				}
				commit(data).then(res => {
					this.loading = false;
					if(res.code == "OK") {
						this.$store.dispatch('user/addmessage');
						this.$message.success('提交成功');
						this.$router.back(-1);
					}
				}).catch(err => {
					this.loading = false;
				})
			},
			jumpQuestion(questionindex, jump) {
				var qusetionlist = this.qusetionlist;
				var index = this.questionindex;
				if(qusetionlist[index].over == true) {
					var userAnswer = '';
					if(qusetionlist[index].topicType == 4 || qusetionlist[index].topicType == 5) {
						userAnswer = qusetionlist[index].userAnswer
					} else {
						userAnswer = qusetionlist[index].choose.join('')
					}
					var data = {
						topicId: qusetionlist[index].id,
						userAnswer: userAnswer,
						examineId: this.id,
						userExamId: this.userExamId,
						topicType: qusetionlist[index].topicType,
						userAnswerFile: qusetionlist[index].filesurl,
						timeRemaining: this.timelen,
					}
					answer(data).then(res => {
						if(res.code == "OK") {
							qusetionlist[index].overdata = true;
							this.$set(qusetionlist, index, qusetionlist[index])
							this.jump(questionindex, jump)
						}
					})
				} else {
					this.jump(questionindex, jump)
				}
			},
			exitExam() {
				this.$confirm('考试退出后，可重新进入继续考试，确认退出', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$router.back(-1);
				}).catch(() => {});
			},
		},
		beforeRouteLeave(to, from, next) {
			var timereader = this.timereader;
			if(timereader) {
				clearInterval(timereader);
				this.timereader = null;
			}
			var timelaster = this.timelaster;
			if(timelaster) {
				clearInterval(timelaster);
				this.timelaster = null;
			}
			next();
		},
	}
</script>